import { render } from "./DashboardOrdenesEntrega.vue?vue&type=template&id=cbc3a3a2&scoped=true"
import script from "./DashboardOrdenesEntrega.vue?vue&type=script&lang=js"
export * from "./DashboardOrdenesEntrega.vue?vue&type=script&lang=js"

import "./DashboardOrdenesEntrega.vue?vue&type=style&index=0&id=cbc3a3a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc3a3a2"]])

export default __exports__